module.exports = __webpack_public_path__ + "static/img/video3.02f4d3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video3.jpg
// module id = FDCf
// module chunks = 10